const TOKEN_KEY = 'customs_auth_token'
const PERMS_KEY = 'customs_permissions'
const USER_KEY = 'customs_user'
const AUTH_CHANGED_EVENT = 'customs-auth-changed'

function emitAuthChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(AUTH_CHANGED_EVENT))
  }
}

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY) || ''
}

export function setAuth({ token, user }) {
  if (token) {
    sessionStorage.setItem(TOKEN_KEY, token)
  }
  const perms = (user && user.permissions) || []
  sessionStorage.setItem(PERMS_KEY, JSON.stringify(perms))
  sessionStorage.setItem(USER_KEY, JSON.stringify(user || {}))
  emitAuthChanged()
}

export function clearAuth() {
  sessionStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(PERMS_KEY)
  sessionStorage.removeItem(USER_KEY)
  emitAuthChanged()
}

export function getPermissions() {
  try {
    const s = sessionStorage.getItem(PERMS_KEY)
    return s ? JSON.parse(s) : []
  } catch (e) {
    return []
  }
}

export function hasPerm(code) {
  const p = getPermissions()
  if (p.includes('*')) {
    return true
  }
  return p.includes(code)
}

/** 上传管理：菜单 / 查看 / 上传 任一即可进入相关功能 */
export const DECLARATION_UPLOAD_PERMS = [
  'menu.declaration_uploads',
  'declaration_uploads.read',
  'declaration_uploads.write',
]

export function hasAnyPerm(codes) {
  if (!Array.isArray(codes)) {
    return false
  }
  return codes.some((c) => hasPerm(c))
}

export function canAccessDeclarationUploads() {
  return hasAnyPerm(DECLARATION_UPLOAD_PERMS)
}

export function getStoredUser() {
  try {
    const s = sessionStorage.getItem(USER_KEY)
    return s ? JSON.parse(s) : null
  } catch (e) {
    return null
  }
}

export function onAuthChanged(listener) {
  if (typeof window === 'undefined' || typeof listener !== 'function') return () => {}
  window.addEventListener(AUTH_CHANGED_EVENT, listener)
  return () => window.removeEventListener(AUTH_CHANGED_EVENT, listener)
}
